export default __webpack_public_path__ + "static/media/mor.30c93a55.jpg";